var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["nanoid"]: () => (__WEBPACK_EXTERNAL_MODULE_nanoid_non_secure_38f76ec4__.nanoid) });